import { message } from 'antd'
const isProduction = process.env.NODE_ENV === 'production';
const stageUrl = 'http://cdc-hd.elong.com/'
const prodUrl = 'https://da.elong.com/api/'

const serviceMap = {
	'https://da.elong.com': prodUrl,
	'http://cdc-hd.elong.com': stageUrl,
}
const getBaseUrl = () => {
	if (!isProduction) {
		return '/api/'
	}
	const target = serviceMap[location.origin]
	return target || stageUrl
}
class Http {
	constructor() {
		this.defaults = {
			baseURL: getBaseUrl(),
			body: null,
		}
		this.url = ''
		this.options = {
			credentials: 'include',  // 默认启用
			headers: {
				// 'tc-proxy': '1',
				// 'tc-proxyid': process.env.REACT_APP_PROXYID,
			}
		}
	}

	// 合并配置，设置default
	init (url, method) {
		if (!!url) {
			this.url = url
		} else {
			throw new Error('url is necessary')
		}
		this.options.method = method
		this.url = this.defaults.baseURL ? this.defaults.baseURL + this.url : this.url
	}

	// 检查响应状态，返回对应结果
	checkStatus (response) {
		if(response.status >= 200 && response.status < 300) {   //响应成功
			return response
		} else if(response.status === 301 || response.status === 302) {    //重定向
			window.location = response.headers.get('Location')
		} else {
			message.error('网络错误')
		}
		const error = new Error(response.statusText)
		error.data = response
		throw error
	}

	// 通过content-type判断解析方式
	async parseResult(response) {
		const contentType = response.headers.get('content-type')
		if (!!contentType) {
			if(contentType.indexOf('text') > -1) {
				return await response.text()
			}
			if(contentType.indexOf('form') > -1) {
				return await response.formData()
			}
			if(contentType.indexOf('video') > -1) {
				return await response.blob()
			}
			if(contentType.indexOf('json') > -1) {
				const text = await response.text()
				if (!text) return {}
				try {
					return JSON.parse(text)
				} catch (e) {
					return text
				}
			}
		}
		return await response.text()
	}

	// 集中处理请求
	async _request () {
		const options = { ...this.options, headers: { ...this.options.headers } }
		let res = await fetch(this.url, options)
		let response = this.checkStatus(res)
		response = this.parseResult(response)
		return response
	}

	async get (url, options) {
		this.init(url, 'get')
		if(options) {
			this.options = Object.assign(this.options, options)
		}
		if (!!this.options.body && typeof this.options.body === 'object') {
			const esc = encodeURIComponent;
			let query = Object.keys(this.options.body)
				.map(k => esc(k) + '=' + esc(this.options.body[k]))
				.join('&')
			this.url += '?' + query
		}
		this.options.body = null
		return  await this._request()
	}

	async post (url, options) {
		this.init(url, 'post')
		if(!options.formData){
			this.options.headers['Content-Type'] = 'application/json;charset=UTF-8'
		} else {
			delete this.options.headers['Content-Type']
		}
		this.options.mode = 'cors'
		this.options = Object.assign(this.options, options)
		const res =  await this._request()
		if (res.code === 10040) { // 未登录
			localStorage.clear()
			window.location.href =	window.location.href.split('#')[0]
		} else if(res.code === 10029) { // 登录未获取到权限
			res.msg = '请重新登录'
		}
		return res
	}
}

export default new Http()

